<template>
  <div class="main-body">
    <div class="header">健康档案</div>
    <div class="out">

      <div>
        <div style="float:left;width: 300px;margin-right: 10px;">

          <el-card class="box-card" :body-style='{padding:"0px"}'>

            <div class="search2">

              <div style="float:left">

                <el-input v-model="userName" placeholder="老人" disabled style="width: 200px">
                  <el-button slot="append" size="mini" icon="el-icon-search" @click="getElderly"></el-button>
                  <el-button slot="prepend" size="mini" icon="el-icon-close" @click="clearElderly"></el-button>
                </el-input>

                <el-button size="mini" style="margin-left: 5px;" type="primary"  @click="getList2">搜索</el-button>

              </div>

              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData"
                      :height="th" border>
              <el-table-column prop="name" label="姓名" width="80">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openData(scope.row)">{{scope.row.name}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="性别" width="70">
                <template slot-scope="scope">
                  <span v-if="scope.row.gender == 0">女</span>
                  <span v-if="scope.row.gender == 1">男</span>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄"></el-table-column>
            </el-table>
          </el-card>

        </div>

        <div style="float:left;" :style="bodyStyle">

          <el-card class="box-card" :body-style='{padding:"0px",height:"140px"}'>
            <el-col :span="item.row" v-for="(item,i) in gridList" :key="i">
              <div v-if="item.name!='more'">
                <div style="color: gray;padding: 5px;">{{item.name}}</div>
                <div style="padding: 5px;">{{item.value}}</div>
                <div style="clear:both"></div>
              </div>
              <div v-else>
                <div style="height: 25px;"></div>
                <el-button type="text" @click="handleElderlyInfo()">详细信息</el-button>
              </div>
            </el-col>
          </el-card>

          <div style="height: 10px;"></div>

          <el-tabs type="border-card" :before-leave='beforeLeave' v-model="activeName" :style="bodyStyle2">
            <el-tab-pane v-for="(item,i) in tableData2" :key="i" :label="item.name">
              <component :is="item.currentRole" ref="component"/>
            </el-tab-pane>
          </el-tabs>

        </div>
        <div style="clear:both;"></div>
      </div>


    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly"
             v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

    <XueYa ref="myXueYa" v-show="false"></XueYa>
    <XinLv ref="myXinLv" v-show="false"></XinLv>
    <XueYang ref="myXueYang" v-show="false"></XueYang>
    <TiWen ref="myTiWen" v-show="false"></TiWen>
    <XueTang ref="myXueTang" v-show="false"></XueTang>
    <NiaoSuan ref="myNiaoSuan" v-show="false"></NiaoSuan>
    <DGChun ref="myDGChun" v-show="false"></DGChun>
    <GYSZhi ref="myGYSZhi" v-show="false"></GYSZhi>

    <MedicalRecords ref="myMedicalRecords" v-show="false"></MedicalRecords>
    <ExaminationRecords ref="myExaminationRecords" v-show="false"></ExaminationRecords>
    <SeeDoctorRecords ref="mySeeDoctorRecords" v-show="false"></SeeDoctorRecords>
    <HealthRecord ref="myHealthRecord" v-show="false"></HealthRecord>
    <HealthInfo ref="myHealthInfo" v-show="false"></HealthInfo>
    <ScanRecord ref="myScanRecord" v-show="false"></ScanRecord>

    <ElderlyOrder ref="myElderlyOrder" v-show="false"></ElderlyOrder>
    <ElderlyOrderMonth ref="myElderlyOrderMonth" v-show="false"></ElderlyOrderMonth>

    <el-dialog title="老人信息" :visible.sync="showModalInfo" class="dialog" width='1000px'
               center top='10vh' :close-on-click-modal='false'>
      <InfoMain ref="myInfoMain"></InfoMain>
    </el-dialog>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode,} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyGov";
import InfoMain from "@/views/Elderly/Info/Main";

import XueYa from "./XueYa";
import XinLv from "./XinLv";
import XueYang from "./XueYang";
import TiWen from "./TiWen";
import XueTang from "./XueTang";
import NiaoSuan from "./NiaoSuan";
import DGChun from "./DGChun";
import GYSZhi from "./GYSZhi";

import MedicalRecords from "./MedicalRecords";
import ExaminationRecords from "./ExaminationRecords";
import SeeDoctorRecords from "./SeeDoctorRecords";
import HealthRecord from "./HealthRecord";
import HealthInfo from "./HealthInfo";
import ScanRecord from "./ScanRecord";

import ElderlyOrder from "./ElderlyOrder";
import ElderlyOrderMonth from "./ElderlyOrderMonthOut";

export default {
  name: "Role",
  data(){
    return{
      tableLoading:false,

      showModalGetElderly:false,
      showModalLine:false,
      showModalInfo:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      elderlyCode:'',
      userName:'',

      activeName:'0',
      tableData2: [
        {name: '血压',currentRole:'XueYa',isNone:false},
        {name: '心率',currentRole:'XinLv',isNone:true},
        {name: '血氧',currentRole:'XueYang',isNone:true},
        //{name: '体温',currentRole:'TiWen',isNone:true},
        {name: '血糖',currentRole:'XueTang',isNone:true},
        {name: '尿酸',currentRole:'NiaoSuan',isNone:true},
        {name: '胆固醇',currentRole:'DGChun',isNone:true},
        {name: '甘油三酯',currentRole:'GYSZhi',isNone:true},

        {name: '日常用药',currentRole:'MedicalRecords',isNone:true},
        {name: '体检记录',currentRole:'ExaminationRecords',isNone:true},
        {name: '就诊记录',currentRole:'SeeDoctorRecords',isNone:true},
        {name: '健康履历',currentRole:'HealthRecord',isNone:true},
        {name: '健康信息',currentRole:'HealthInfo',isNone:true},
        {name: '扫描文件',currentRole:'ScanRecord',isNone:true},

        {name: '服务订单',currentRole:'ElderlyOrder',isNone:true},
        {name: '服务项目',currentRole:'ElderlyOrderMonth',isNone:true},
      ],

      userCode:'',
      elderlyCode2:'',
      elderlyName2:'',

      gridList:[],

      mw:0,

      bodyStyle: "width:" + (this.mw) + 'px',
      bodyStyle2: "height:" + (this.th) + 'px',

    }
  },

  created(){

    this.getList2();
    this.th = this.$store.state.tableHeight+45;


    this.$nextTick(()=>{
      var appNav = document.getElementsByClassName('app-nav');
      this.mw = this.$store.state.tableWidth - appNav[0].scrollWidth ;
      this.bodyStyle= "width:" + (this.mw-350) + 'px';
    })

    this.bodyStyle2= "height:" + (this.th-105) + 'px';


  },

  components:{
    Elderly,XueYa,XinLv,XueYang,TiWen,XueTang,NiaoSuan,DGChun,GYSZhi,
    MedicalRecords,ExaminationRecords,
    SeeDoctorRecords,ScanRecord,
    HealthRecord,HealthInfo,
    InfoMain,ElderlyOrder,ElderlyOrderMonth
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+45;
      this.bodyStyle2= "height:" + (this.th-105) + 'px';
    },
    '$store.state.tableWidth' : function(val){

      var appNav = document.getElementsByClassName('app-nav');

      this.mw = val - appNav[0].scrollWidth ;
      this.bodyStyle= "width:" + (this.mw-350) + 'px';

    },
  },
  methods:{

    openData(row){

      this.userCode = row.userCode;
      this.elderlyCode2 = row.elderlyCode;
      this.elderlyName2 = row.name;


      this.tableData2.forEach((item)=>{
        item.isNone=false
      })
      this.activeName='0'
      this.tableData2[0].isNone=true
      this.$nextTick(() => {
        this.$refs.component[0].init(this.userCode);
      })


      this.gridList = [];
      var genderList = ['女','男']
      this.gridList.push(
          {row:8,name:'姓名',value:row.name},
          {row:8,name:'手机号',value:row.phone},
          {row:8,name:'证件号',value:row.idCard==null||row.idCard==''?'-':row.idCard},
          //{row:8,name:'出生日期',value:row.birthday==null||row.birthday==''?'-':timefilters(row.birthday).slice(0,10)},
          {row:8,name:'性别/年龄',value:genderList[row.gender]+'/'+row.age},
          {row:8,name:'居住地址',value:row.homeAddress==null||row.homeAddress==''?'-':row.homeAddress},
          {row:8,name:'more',value:row.name},
      );



    },

    beforeLeave(activeName){
      this.tableData2[parseInt(activeName)].isNone=true
      this.$nextTick(() => {
        this.$refs.component[parseInt(activeName)].init(this.userCode,this.elderlyCode2,this.elderlyName2);
      })
    },



    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.elderlyCode = '';
      this.userName = '';
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList2();
    },
    getList2(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyAdm/GovPageType",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),

          pageIndex: 1,
          pageSize: 20,

          elderlyType:-1,
          elderlyCode:this.elderlyCode,
          zoneCode:'',

        }
      }).then( (response)=> {
        _this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;

          if(this.tableData.length>0){
            this.userCode = this.tableData[0].userCode;
            this.elderlyCode2 = this.tableData[0].elderlyCode;
            this.openData(this.tableData[0]);
          }


        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    handleElderlyInfo(){
      this.showModalInfo = !this.showModalInfo;
      this.$nextTick(()=>{
        let row = {"elderlyCode":this.elderlyCode2,"userCode":this.userCode};
        this.$refs.myInfoMain.init(row);
      });

    },


  }
}
</script>

<style scoped>

</style>
